// import { getFirestore } from '../../system/firebase';

// import { LABEL_COMPANY_SIZE, LABEL_INDUSTRY /*, LABEL_LOCATION */ } from '../constants';
import { mapDefinedFields } from '../dtoHelper';
import { ELASTICSEARCH_PAGE_SIZE, getLocationQueryObject, mapProfilesEmpDataFromElasticSearchJson } from '../elasticSearchHelper';
import { elasticSearchEmployerSearchPostFetch } from './appServices';
import { checkEsToken } from './appServices';

import _get from 'lodash/get';
import _map from 'lodash/map';
import _omit from 'lodash/omit';

export const searchEmployers = async ({ from = 0, size = ELASTICSEARCH_PAGE_SIZE, queryObject, esToken, setEsToken } = {}) => {
    // format the search criteria queryObject
    const location = _get(queryObject, 'location.value'); // location is a label-value pair from suggestion
    let locationQueryObject = getLocationQueryObject({ location });
    // const sortDto = queryObject?.sortTag || undefined;

    // Create the actual queryObject for ElasticSearch
    const mappedQueryObject = mapDefinedFields({
        companyName: queryObject?.searchText || undefined,
        industry: queryObject?.industry || undefined,
        companySize: queryObject?.companySize || undefined,
        ...locationQueryObject,
        //     ...sortDto,
    });
    // console.log('==========> ', { mappedQueryObject });

    let checkedEsToken = null;
    try {
        checkedEsToken = await checkEsToken(esToken);

        if (checkedEsToken) {
            const searchResult = await elasticSearchEmployerSearchPostFetch({ queryObject: { ...mappedQueryObject, from, size }, token: checkedEsToken.token });

            if (_get(searchResult, 'success')) {
                const total = _get(searchResult, 'total', 0);
                const result = _get(searchResult, 'result', []);
                const mappedList = _map(result, empItem => {
                    return mapProfilesEmpDataFromElasticSearchJson(empItem);
                });
                return { total, list: mappedList };
            } else {
                console.error('Failed to search employers');
            }

            if (checkedEsToken.isNew) {
                setEsToken(_omit(checkedEsToken, 'isNew'));
            }
        }
    } catch (error) {
        console.error('Failed checking token', error);
    }

    return { total: 0, list: [] };
};

// export const searchEmployers = ({ /*searchString,*/ filters, haveActiveJobs, sortBy, setData }) => {
//     const db = getFirestore();
//     const industryFilter = _get(filters, 'industry');
//     const companySizeFilter = _get(filters, 'companySize');
//     // const locationFilter = _get(filters, 'location');

//     //-------------------------------------------------------------------
//     // Prep for profilesEmp
//     //-------------------------------------------------------------------
//     let profilesRef = db.collection('profilesEmp');

//     //-------------------------------------------------------------------
//     // Apply filter(s)
//     //-------------------------------------------------------------------
//     if (haveActiveJobs) {
//         profilesRef = profilesRef.where('activeJobsCount', '>', 0);
//     }

//     if (industryFilter) {
//         profilesRef = profilesRef.where('info.industry', '==', industryFilter);
//     }
//     if (companySizeFilter) {
//         profilesRef = profilesRef.where('info.companySize', '==', companySizeFilter);
//     }
//     // if (locationFilter) {
//     //     // ElasticSearch on city/state/country
//     // }

//     //-------------------------------------------------------------------
//     // Sort results
//     //-------------------------------------------------------------------
//     if (sortBy === LABEL_INDUSTRY) {
//         profilesRef = profilesRef.orderBy('info.industry');
//     }
//     if (sortBy === LABEL_COMPANY_SIZE) {
//         profilesRef = profilesRef.orderBy('info.companySize', 'desc');
//     }
//     // if (sortBy === LABEL_LOCATION) {
//     //     // ElasticSearch order by lat/long (cityLocation)
//     // }

//     //-------------------------------------------------------------------
//     // Execute query
//     //-------------------------------------------------------------------
//     return profilesRef.onSnapshot(docSnapshot => {
//         //TODO Remove hard-coded repeating results
//         // setData(docSnapshot.docs.map(doc => ({ ...doc.data(), employerId: doc.id })));
//         const tempResults = docSnapshot.docs.map(doc => ({ ...doc.data(), employerId: doc.id }));
//         setData([...tempResults, ...tempResults, ...tempResults, ...tempResults, ...tempResults, ...tempResults, ...tempResults]);
//     });
// };
